import {Component, Inject, NgZone} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@modules/authentication';

export interface OpenBadge {
    id: string;
    name: string;
    image: string;
    type: string;
}

@Component({
    selector: 'rewards-dialog',
    templateUrl: './rewards-dialog.component.html',
    styleUrls: ['./rewards-dialog.component.scss'],
    standalone: false
})
export class RewardsDialogComponent {
    public authorizeNext = true;
    public titleDialog: string;
    public bodyDialog: string;
    public labelExit: string;
    public labelNext: string;
    public coinsName: string;
    public image: string;
    public firstTimeExperience: boolean;
    public coins: number;
    public achievements: OpenBadge[] = [];
    public anyRewards = false;
    public canExit = true;

    constructor(
        public dialogRef: MatDialogRef<RewardsDialogComponent>,
        private authService: AuthenticationService,
        private zone: NgZone,
        @Inject(MAT_DIALOG_DATA) data) {

        this.authorizeNext = data.authorizeNext;
        this.titleDialog = data.titleDialog;
        this.bodyDialog = data.bodyDialog;
        this.labelNext = data.labelNext;
        this.labelExit = data.labelExit;
        if (data.userSave) {
            this.coins = data.userSave.get('config')?.points || 0;
            this.coinsName = data.coinsName;
            this.achievements = data.userSave.get('config')?.achievements || [];
        }
        this.image = data.image;
        this.firstTimeExperience = data?.firstTimeExperience;
        this.anyRewards =(-this.coins > 0 || this.achievements.length > 0 || this.firstTimeExperience) && this.authService.isLearner();
        this.dialogRef.afterOpened().subscribe(() => {
            // quick fix : modal is on top of iframe and angular wait for focus to resume
            this.zone.run(() => {
            });
        });
        this.canExit = "canExit" in data ? data.canExit : true;
    }
}